/**
 * Parse a comma-separated string of OIDC scopes into a deduplicated array.
 */
export function parseScopes(input: string): string[] {
    return input
        .split(",")
        .map((s) => s.trim())
        .filter((s) => s.length > 0);
}
